export const RESEAUX = [
  { key: 'site', nom: 'Site web', icon: '🌐', base: '' },
  { key: 'instagram', nom: 'Instagram', icon: '📷', base: 'https://instagram.com/' },
  { key: 'facebook', nom: 'Facebook', icon: '📘', base: 'https://facebook.com/' },
  { key: 'linkedin', nom: 'LinkedIn', icon: '💼', base: 'https://www.linkedin.com/in/' },
  { key: 'tiktok', nom: 'TikTok', icon: '🎵', base: 'https://www.tiktok.com/@' },
  { key: 'youtube', nom: 'YouTube', icon: '▶️', base: 'https://youtube.com/@' },
  { key: 'taplink', nom: 'TapLink', icon: '🔗', base: '' },
  { key: 'whatsapp', nom: 'WhatsApp', icon: '💬', base: 'https://wa.me/' },
];

export const reseauURL = (key, val) => {
  if (!val) return '';
  const v = String(val).trim();
  if (/^https?:\/\//i.test(v)) return v;
  if (key === 'whatsapp') return 'https://wa.me/' + v.replace(/[^0-9]/g, '');
  const p = RESEAUX.find((r) => r.key === key);
  if (p && p.base) return p.base + v.replace(/^@+/, '').replace(/^\//, '');
  return 'https://' + v.replace(/^@+/, '');
};

export const reseauLabel = (key, val) => {
  const v = String(val || '').trim();
  if (key === 'site' || key === 'taplink') return v.replace(/^https?:\/\//, '').replace(/\/$/, '');
  if (key === 'whatsapp') return v;
  return v.startsWith('@') ? v : '@' + v;
};
